import type { SVGAttributes } from 'react';

export function WaveSvg(props: SVGAttributes<SVGElement>) {
  return (
    <svg {...props} viewBox="0 0 100 100" preserveAspectRatio="none">
      <path d="M100 100 H0 V100 H0 V50 C 33.3333 100, 66.6666 0, 100 50" />
    </svg>
  );
}
